const translations = {
    mapTab: 'Map Info',
    noProductUsageReports: 'No product usage reports attached.',
    productUsageReportTab: 'Product Usage Reports'
};

export default translations;
